/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_EnterInputs */

const en_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter`)
};

const ar_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دخول`)
};

const de_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreten`)
};

const es_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const fr_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrer`)
};

const it_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra`)
};

const ja_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入店する`)
};

const ko_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입장하기`)
};

const pt_br_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const ru_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

const th_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าร้าน`)
};

const tr_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş Yap`)
};

const zh_cn_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进入烘焙坊`)
};

const zh_tw_btn_enter = /** @type {(inputs: Btn_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進入烘焙坊`)
};

/**
* | output |
* | --- |
* | "Enter" |
*
* @param {Btn_EnterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_enter = /** @type {((inputs?: Btn_EnterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_EnterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_enter(inputs)
	if (locale === "ar") return ar_btn_enter(inputs)
	if (locale === "de") return de_btn_enter(inputs)
	if (locale === "es") return es_btn_enter(inputs)
	if (locale === "fr") return fr_btn_enter(inputs)
	if (locale === "it") return it_btn_enter(inputs)
	if (locale === "ja") return ja_btn_enter(inputs)
	if (locale === "ko") return ko_btn_enter(inputs)
	if (locale === "pt_br") return pt_br_btn_enter(inputs)
	if (locale === "ru") return ru_btn_enter(inputs)
	if (locale === "th") return th_btn_enter(inputs)
	if (locale === "tr") return tr_btn_enter(inputs)
	if (locale === "zh_cn") return zh_cn_btn_enter(inputs)
	return zh_tw_btn_enter(inputs)
});